import { updateItemInCollection } from "directus/src/operations";

export async function updateDepartment({ item, departmentId }) {
  try {
    const data = await updateItemInCollection("departments", departmentId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
